import "../Asm/Asm.css";

import arr from "../../images/arrow-s.svg";

import { IMG_URL } from "../../config";
import { useEffect, useState } from "react";


const QUIET_ALT_TEXTS = [
  "Quiet personality type – introverted, reserved and values solitude. Discover your archetype with Personality Peek.",
  "Real personality type – logical, practical and fact-focused. Explore your grounded side with Personality Peek quiz.",
  "Logic personality type – analytical, fact-driven and structured. Uncover your mindset with the Personality Peek quiz.",
  "Mapped personality type – organized, structured, and goal-oriented. Discover your planning style with Personality Peek quiz.",
  "Calm personality type – peaceful, composed, and reflective. Discover your inner balance with Personality Peek quiz.",
 
  "Group personality type – thrives in social settings and teamwork. Find your social archetype with Personality Peek quiz."
];

const OUTGOING_ALT_TEXTS = [
  "Outgoing personality type – sociable, energetic and thrives in groups. Discover your social energy with Personality Peek.",
  "Discover your vivid side – imaginative, creative and sensory-inspired. Take the Personality Peek quiz.",
  "Guided by empathy and emotion – discover your Heart type. Take the Personality Peek quiz.",
  "Spontaneous and adventurous – embrace your Wild side. Discover your free spirit with the Personality Peek quiz.",
  "Zesty personality type – energetic, lively, and enthusiastic. Explore your vibrant side with Personality Peek quiz.",
   "Independent and introspective – embrace your Alone side. Discover your quiet strength with the Personality Peek quiz."
];



function Asm({ data, archetype, asm_page }) {
  const Asmdata = data?.length > 0 ? data[0] : null;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data?.length > 0) {
      setIsLoading(false);
    }
  }, [data]);

  return (
    <div className="asm-section">
      {/* {isLoading ? ( */}
        {/* // <div className="skeleton33 skldivs33"></div>
      ) : ( */}
        <div className="container">
          <div className="row row-for-title-div">
            <div className="asm-title-div">
              <h3 className="asm-title-div-h3">
                {Asmdata?.asm_page_heading}
              </h3>

              <p
                className="asm-title-div-p"
                dangerouslySetInnerHTML={{
                  __html: Asmdata?.asm_page_sub_heading
    
                }}
              ></p>
            </div>
          </div>

          <div className="row gy-4 asm-row">
            {isLoading
              ? Array.from({ length: 2 }).map((_, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    {/* <div className="asm-box1 skeleton"></div> */}
                  </div>
                ))
              : archetype?.map((value, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    <div className="asm-box1">
                      <div className="asm-cards">
                        <div className="asm-card-bx1">
                          <div className="asm-icons">
                            <img
  src={`${IMG_URL}/d0/${value?.quiet_image}`}
  alt={QUIET_ALT_TEXTS[index] || "Personality archetype image"}
/>

                          </div>
                          <div className="asm-contents">
                            <h5>{value?.quiet_heading}</h5>
                            <p>{value?.quiet_description}</p>
                          </div>
                        </div>

                        {/* Arrow / Middle Part */}
                        <div className="asm-card-bx2">
                          <img
                            // loading="lazy"
                            // decoding="async"
                            src={arr}
                            alt=""
                          />
                        </div>

                        {/* Outgoing Image + Content */}
                        <div className="asm-card-bx3">
                          <div className="asm-icons3">
                           <img
  src={`${IMG_URL}/d0/${value?.outgoing_image}`}
  alt={OUTGOING_ALT_TEXTS[index] || "Personality archetype image"}
/>

                          </div>
                          <div className="asm-contents3">
                            <h5>{value?.outgoing_heading}</h5>
                            <p>{value?.outgoing_description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        </div>
      {/* )} */}
    </div>
  );
}

export default Asm;
